

import React, { useRef } from 'react';
import { Field, ErrorMessage, useField } from "formik";
import '../CustomInputLogin/CustomInputLogin.css';
import { BiBorderRadius } from 'react-icons/bi';
import { Typography } from '@mui/material';
import { Height } from '@mui/icons-material';

const CustomDateInput = ({ label, name, editData, ...rest }) => {
  const [field, meta] = useField(name);

  // Get today's date in YYYY-MM-DD format
  const today = new Date().toISOString().split("T")[0];
  const dateInputRef = useRef(null);
  
  
  const handleClick = () => {
    if (dateInputRef.current) {
      dateInputRef.current.showPicker(); // for modern browsers
      dateInputRef.current.focus();      // fallback for others
    }
  };

  return (
    <div style={{ width: "100%" }}>
      <div style={{ width: "96%" }}>
        {/* <div
          style={{ marginBottom: "7px" }}
        > */}
        {/* <label
            htmlFor={name}
            className="input-heading12"
            style={{ fontSize: "16px", fontWeight: "400" }}
          >
            {label}
          </label> */}
        {/* <Typography variant="body1" sx={{ color: "gray"}}>
          {label}
        </Typography> */}
        <Typography variant="subtitle1" sx={{
          color: "gray",
          fontSize: "15px",
          mb: 1
        }}>{label}</Typography>
        {/* </div> */}

        <Field
          onClick={handleClick}
        
          {...field}
          id={name}
          name={name}
          type="date"
          ref={dateInputRef}
          
          placeholder="Enter Input"
          // min={editData ? undefined : today} // Disable past dates
          {...rest}
          className='custominput-field12'
          style={{ borderRadius: "3px",height:"40px" }}
        />
        <ErrorMessage name={name} component="div" className="inputs-error-msg" style={{ color: "red", fontSize: "12px" }} />
      </div>
    </div>
  );
};

export default CustomDateInput;

